import styled from 'styled-components';
import TextView from '../../TextView';
import { colors } from '../../../utils';

// Styled container for title and span
export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  width: 100%;
`;

// Styled text container for the title
export const TitleText = styled(TextView)`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  font-family: 'DM Sans', sans-serif;
  color: ${colors.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 0.75rem;
  }

  @media (max-width: 480px) {
    font-size: 0.5rem;
  }
`;

// Styled span for the count
export const CountSpan = styled(TextView)`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  font-family: 'DM Sans', sans-serif;
  color: ${colors.lightGrey};
  font-weight: normal;
  flex-shrink: 0;
`;
